/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskBoxResponse
 */
export interface TaskBoxResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskBoxResponse
     */
    taskBoxId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxResponse
     */
    taskBoxTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxResponse
     */
    taskBoxModuleType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBoxResponse
     */
    taskBoxChannelType?: string;
}

/**
 * Check if a given object implements the TaskBoxResponse interface.
 */
export function instanceOfTaskBoxResponse(value: object): value is TaskBoxResponse {
    return true;
}

export function TaskBoxResponseFromJSON(json: any): TaskBoxResponse {
    return TaskBoxResponseFromJSONTyped(json, false);
}

export function TaskBoxResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskBoxResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskBoxId': json['taskBoxId'] == null ? undefined : json['taskBoxId'],
        'taskBoxTitle': json['taskBoxTitle'] == null ? undefined : json['taskBoxTitle'],
        'description': json['description'] == null ? undefined : json['description'],
        'taskBoxModuleType': json['taskBoxModuleType'] == null ? undefined : json['taskBoxModuleType'],
        'taskBoxChannelType': json['taskBoxChannelType'] == null ? undefined : json['taskBoxChannelType'],
    };
}

export function TaskBoxResponseToJSON(json: any): TaskBoxResponse {
    return TaskBoxResponseToJSONTyped(json, false);
}

export function TaskBoxResponseToJSONTyped(value?: TaskBoxResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskBoxId': value['taskBoxId'],
        'taskBoxTitle': value['taskBoxTitle'],
        'description': value['description'],
        'taskBoxModuleType': value['taskBoxModuleType'],
        'taskBoxChannelType': value['taskBoxChannelType'],
    };
}

